/** @format */

import uuid from 'uuid/v4';

import * as types from '../action-types';
import { isDemoMode } from '../selectors';
import { showDemoUnavailable } from '../utils/demoMode';

// Plain action consumed by the schedule saga / pending reducer.
export const setScheduleStarted = (
  sendWsMessage,
  homeId,
  zoneId,
  newSchedule,
  isHpi,
  requestId = uuid(),
) => ({
  type: types.SET_SCHEDULE_STARTED,
  sendWsMessage,
  homeId,
  zoneId,
  requestId,
  schedule: newSchedule,
  isHpi,
});

// This will trigger the schedule saga to start. Demo mode has no backend to
// confirm the save, so surface the demo-unavailable message instead -
// guarding here covers every schedule screen at once.
export const setSchedule =
  (...args) =>
  (dispatch, getState) => {
    if (isDemoMode(getState())) {
      dispatch(showDemoUnavailable());
      return;
    }
    dispatch(setScheduleStarted(...args));
  };

export const setScheduleSelectedDay = selectedDay => ({
  type: types.SCHEDULE_DAY_SET,
  selectedDay,
});

export const clearScheduleUpdateRequest = () => ({
  type: types.CLEAR_SET_SCHEDULE_REQUEST,
});

// Dispatch one schedule to many zones; saga processes them sequentially and
// emits a single batch terminal action when all zones resolve. Kept module
// local so callers can't bypass the demo guard in setSchedulesBatch.
const setSchedulesBatchStarted = (
  sendWsMessage,
  homeId,
  zoneIds,
  newSchedule,
  isHpi,
  batchRequestId = uuid(),
) => ({
  type: types.SET_SCHEDULES_BATCH_STARTED,
  sendWsMessage,
  homeId,
  zoneIds,
  batchRequestId,
  schedule: newSchedule,
  isHpi,
});

export const setSchedulesBatch =
  (...args) =>
  (dispatch, getState) => {
    if (isDemoMode(getState())) {
      dispatch(showDemoUnavailable());
      return;
    }
    dispatch(setSchedulesBatchStarted(...args));
  };

export const clearSchedulesBatchUpdateRequest = () => ({
  type: types.CLEAR_SET_SCHEDULES_BATCH_REQUEST,
});

// Draft schedule action creators (local changes before API submission)
export const setDraftSchedule = (homeId, zoneId, schedule, originalSchedule) => ({
  type: types.SET_DRAFT_SCHEDULE,
  homeId,
  zoneId,
  schedule,
  originalSchedule,
});

export const clearDraftSchedule = (homeId, zoneId) => ({
  type: types.CLEAR_DRAFT_SCHEDULE,
  homeId,
  zoneId,
});

export const clearAllDraftSchedules = () => ({
  type: types.CLEAR_ALL_DRAFT_SCHEDULES,
});
